import PageWrapper from "@/components/layout/page-wrapper";
import LayoutTabHeader from "@/components/chat-settings/layout-tab-header/layout-tab-header";
import { Outlet, useLocation } from "react-router";

const getTitle = (pathname: string) => {
    return pathname
        .split("?")[0]
        .split("/")
        .pop()
        ?.replace(/-/g, " ")
        .replace(/\b\w/g, function (l) {
            return l.toUpperCase();
        });
};

const ChatSettingsLayout = () => {
    const location = useLocation();
    return (
        <PageWrapper
            pageTitle={`${getTitle(location.pathname)}`}
            currentPage={`${getTitle(location.pathname)}`}
            previousPages={[{ title: "Chat Settings", url: "/app/chat-settings" }]}
        >
            <>
                <LayoutTabHeader />
            </>
            <Outlet />
        </PageWrapper>
    );
};

export default ChatSettingsLayout;
